(ns app.front.view.group.admin.config.sign-off
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.config-selectors :as conf-sel]
            [app.front.view.group.admin.config.form-schema-subs :as cfs-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]))

(defn sign-off-config [{:keys [tr *group-config parent-config target] :as editor-ctx}]
  (let [[parent-schema-id parent-config-name] (:application-sign-off-schema parent-config)
        configured-here?                      (some? (:group.config/application-sign-off-schema @*group-config))
        configured-in-parent?                 (some? parent-schema-id)
        configured?                           (or configured-here? configured-in-parent?)]
    [:<>
     (cc/form-group
       {:legend-text (tr [:group-admin/sign-off-form])}
       (into
         (cc/select
           {:id          (str target "/select-sign-off-form")
            :hide-label  true
            :class-name  "select-w-full"
            :label-text  (tr [:group-admin/sign-off-form])
            :helper-text (if (and (not configured-here?)
                                  configured-in-parent?)
                           (tr [:group-admin/disabled-reason] [parent-config-name])
                           "")
            :on-change   #(let [v     (futil/tval %)
                                none? (= "none" v)
                                v     (when-not none?
                                        (js/parseInt v))]
                            (swap! *group-config assoc :group.config/application-sign-off-schema v)
                            (when none?
                              ;; Remove roles / declarations and submission sign-off requirement from this level 
                              ;; if sign-off form is disabled so that we don't force declarations downstream
                              (swap! *group-config (fn [cfg]
                                                     (-> cfg
                                                         (assoc :group.config/sign-off-declarations #{})
                                                         (assoc :group.config/require-sign-off-after-changes-requested? nil))))))
            :value       (or (:group.config/application-sign-off-schema @*group-config) parent-schema-id :none)}
           (ui/placeholder-select-item tr :none {:text (tr [:none])}))
         (for [schema (<sub [::cfs-subs/sign-off-schemas])
               :let   [schema-id (:db/id schema)]]
           (cc/select-item {:text  (:form.schema/name schema)
                            :value schema-id}))))
     (when configured?
       [conf-sel/sign-off-req-roles-editor editor-ctx])]))

(defn permit-sign-off-config [{:keys [tr *group-config parent-config permit-type target] :as ctx}]
  (when (and (contains? ptc-model/permit-types-with-permit-sign-off permit-type)
             (or (not= permit-type :permit-type/P)
                 (= (:group.config/process-flow @*group-config)
                    :process-flow/land-use)))
    (let [express-issuance-active? (or (:group.config/express-issuance? @*group-config)
                                       (:group.config/express-issuance? parent-config))
          parent-sign-off?         (-> parent-config :group.config/permit-sign-off? boolean)
          checked?                 (->> parent-sign-off?
                                        (vector (:group.config/permit-sign-off? @*group-config))
                                        (some true?)
                                        boolean)]
      [:div.md:flex
       (cc/form-group
         {:legend-text (tr [:group-admin/permit-sign-off])}
         (if express-issuance-active?
           (cc/checkbox {:id         (str "permit-sign-off" target)
                         :label-text (tr [:group.config/permit-sign-off?])
                         :checked    false
                         :disabled   true})
           [acommon/checkbox ctx :group.config/permit-sign-off?])
         (if express-issuance-active?
           [ui/help (tr [:group-admin/permit-sign-off-incompatible-with-express-issuance])]
           (when checked?
             [ui/help (tr [:group-admin/permit-sign-off-help])])))])))
